var _defs, _circle, _polyline, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 18",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,\n            .cls-2,\n            .cls-3 {\n                fill: none;\n            }\n\n            .cls-1,\n            .cls-2 {\n                stroke: #7d7d7d;\n                stroke-miterlimit: 10;\n            }\n\n            .cls-1 {\n                stroke-width: 0.98px;\n            }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 8,
  cy: 9.5,
  r: 7.5
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-2",
  points: "11.08 12.39 8.7 10.01 8.5 9.81 8.5 5.5"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: -9.92,
  y: -320.89,
  width: 1024,
  height: 900
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export default ForwardRef;